import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { ButtonModule } from 'primeng/button'
import { CardModule } from 'primeng/card'
import { ProgressBarModule } from 'primeng/progressbar'
import { ToastModule } from 'primeng/toast'
import { TermsAndConditionsModule } from '../terms-and-conditions/terms-and-conditions.module'
import { ToastExtensionModule } from '../toast-extension/toast-extension.module'
import { CardLayoutContentDescriptionComponent } from './card-layout-content-description/card-layout-content-description.component'
import { CardLayoutContentHeaderComponent } from './card-layout-content-header/card-layout-content-header.component'
import { CardLayoutContentImageComponent } from './card-layout-content-image/card-layout-content-image.component'
import { CardLayoutContentSubtitleComponent } from './card-layout-content-subtitle/card-layout-content-subtitle.component'
import { CardLayoutContentTitleComponent } from './card-layout-content-title/card-layout-content-title.component'
import { CardLayoutContentComponent } from './card-layout-content/card-layout-content.component'
import { CardLayoutComponent } from './card-layout.component'

@NgModule({
  declarations: [
    CardLayoutComponent,
    CardLayoutContentComponent,
    CardLayoutContentHeaderComponent,
    CardLayoutContentTitleComponent,
    CardLayoutContentDescriptionComponent,
    CardLayoutContentSubtitleComponent,
    CardLayoutContentImageComponent,
  ],
  imports: [
    CardModule,
    CommonModule,
    RouterModule,
    ButtonModule,
    ProgressBarModule,
    ToastModule,
    TermsAndConditionsModule,
    ToastExtensionModule,
  ],
  exports: [
    CardLayoutComponent,
    CardLayoutContentComponent,
    CardLayoutContentHeaderComponent,
    CardLayoutContentTitleComponent,
    CardLayoutContentDescriptionComponent,
    CardLayoutContentSubtitleComponent,
    CardLayoutContentImageComponent,
  ],
})
export class CardLayoutModule {}
